export const DEFAULT_JOB_APPLICATION_SORT = Object.freeze({
  sort_by: 'created_at',
  sort_order: 'DESC',
});

const COLUMN_TO_FIELD = Object.freeze({
  name: 'name',
  gender: 'gender',
  age: 'age',
  location: 'country_id',
  status: 'status_id',
  manager: 'manager_id',
  created: 'created_at',
});

const FIELD_TO_COLUMN = Object.freeze(
  Object.fromEntries(Object.entries(COLUMN_TO_FIELD).map(([column, field]) => [field, column])),
);

const ALLOWED_SORT_FIELDS = new Set([
  'name',
  'id',
  'manager_id',
  'gender',
  'age',
  'country_id',
  'status_id',
  'created_at',
]);

export function normalizeJobApplicationSort(sortBy, sortOrder) {
  if (!ALLOWED_SORT_FIELDS.has(sortBy)) return { ...DEFAULT_JOB_APPLICATION_SORT };
  return {
    sort_by: sortBy,
    sort_order: sortOrder === 'ASC' || sortOrder === 'DESC'
      ? sortOrder
      : (sortBy === DEFAULT_JOB_APPLICATION_SORT.sort_by ? 'DESC' : 'ASC'),
  };
}

export function getJobApplicationSortField(column) {
  return COLUMN_TO_FIELD[column] || column;
}

export function getJobApplicationColumnKey(field) {
  return FIELD_TO_COLUMN[field] || field;
}
